import {useAppConfig} from './config';
import {Configuration} from './generated/apiclient';
import AuthProvider from './AuthProviders/AWSCognito';

export const useApiConfig = () => {
    const config = useAppConfig();

    return AuthProvider.getToken().then((token) => {
        const c = new Configuration({
            basePath: config.basePath,
            accessToken: token,
            baseOptions: {withCredentials: true},
        });

        return c;
    });
};
